import axios from "axios";
import { realtyStore } from "../store";
import { IMAGE_SIDES } from "../constants/common";
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { broadcastAuthLogout } from "./authSession";

export {
  formatInternationalPhone,
  formatPhoneForDisplay,
  getPhoneHref,
} from "./phone";

let store;

export const injectStore = (storeVal) => {
  store = storeVal;
};

export const apiClient = axios.create({
  responseType: "json",
});

// Public endpoints must never inherit the session-aware Authorization interceptor.
export const publicApiClient = axios.create({
  responseType: "json",
});

const getCookieValue = (name: string): string => {
  const rawValue = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`))
    ?.split("=")[1];

  return rawValue ? decodeURIComponent(rawValue) : "";
};

const normalizeBearerToken = (value: unknown): string => {
  const token = String(value || "").trim();
  return token && token !== "undefined" && token !== "null" ? token : "";
};

apiClient.interceptors.request.use((config) => {
  const activeStore = store || realtyStore;
  const token = normalizeBearerToken(
    activeStore?.getState?.()?.userReducer?.userData?.data?.token || getCookieValue("userToken"),
  );

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
    delete config.headers.authorization;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const activeStore = store || realtyStore;
      activeStore?.dispatch?.({ type: "user/logout" });
      broadcastAuthLogout();
    }

    return Promise.reject(error);
  },
);

export const getImageBiggerSide = (imageUrl: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      if (img.height > img.width) {
        resolve(IMAGE_SIDES.height);
      } else {
        resolve(IMAGE_SIDES.width);
      }
    };

    img.onerror = (error) => {
      console.error(`Ошибка загрузки изображения: ${imageUrl}`, error);
      reject(`Ошибка загрузки изображения: ${imageUrl}`);
    };

    img.src = imageUrl;
  });
};

export const isShared = window?.location?.pathname.includes("shared");

export const getRandomNumber = (max: number) =>
  Math.floor(Math.random() * (max + 1));

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
